import { ILoteAgendamentoTipoAtendimento } from "../types/loteAgendamento";

export const MODALIDADE_POR_TIPO_ATENDIMENTO: Record<
  ILoteAgendamentoTipoAtendimento,
  string
> = {
  LOJA: "Loja",
  DOMICILIO: "Delivery",
  ITINERANTE: "Itinerante",
};
